<form [formGroup]="empInsuranceForm" (ngSubmit)="saveEmpInsurance(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-file-shield-line  me-1 font-20 text-primary"></i>
      {{ empInsuranceForm.value.id ? 'Update' : 'Add' }} Coverage 
      -   {{ employeeName || context?.employeeName}}
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-3">
        <label for="policy" class="form-label">Policy<b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layout'></i></span>
          <input type="text" class="form-control ps-1" id="policy" placeholder="Enter the Policy"
            [ngClass]="{'is-invalid': submitted && i.policy.errors}" formControlName="policy" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && i.policy.errors">
            <span *ngIf="i.policy.errors.required">Please provide a valid policy.</span>
            <span *ngIf="i.policy.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="startDate" class="form-label">Start Date <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-calendar'></i>
          </span>
          <input type="date" class="form-control ps-1" id="startDate" formControlName="startDate"
            [ngClass]="{'is-invalid': submitted && i.startDate.errors}"/>
          <div class="invalid-feedback" *ngIf="submitted && i.startDate.errors">
            <span *ngIf="i.startDate.errors.required">Please provide a valid start date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="endDate" class="form-label">End Date <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-calendar'></i>
          </span>
          <input type="date" class="form-control ps-1" id="endDate" formControlName="endDate"
            [ngClass]="{'is-invalid': submitted && i.endDate.errors}" [min]="empInsuranceForm.value.startDate" />
          <div class="invalid-feedback" *ngIf="submitted && i.endDate.errors">
            <span *ngIf="i.endDate.errors.required">Please provide a valid end date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="nextNotification" class="form-label">Next Notification<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-calendar'></i>
          </span>
          <input type="date" class="form-control ps-1" id="nextNotification" formControlName="nextNotification"
            [ngClass]="{'is-invalid': submitted && i.nextNotification.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && i.nextNotification.errors">
            <span *ngIf="i.nextNotification.errors.required">Please provide a valid last notified.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="bank" class="form-label">Bank<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-bank'></i></span>
          <ng-select class="form-control rcx-ng-select" placeholder="Select bank" formControlName="bankId"
            [ngClass]="{'is-invalid': submitted && i.bankId.errors}" [clearable]="false">
            <ng-option *ngFor=" let bank of banks;" [value]="bank.id">{{bank.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && i.bankId.errors">
            <span *ngIf="i.bankId.errors.required">Please select a bank.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="insurance" class="form-label">Insurance<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layout'></i></span>
          <ng-select class="form-control rcx-ng-select" placeholder="Select insurance" formControlName="insuranceId"
            [ngClass]="{'is-invalid': submitted && i.insuranceId.errors}" [clearable]="false" (change)="fetchInsurancePlans($event)">
            <ng-option *ngFor=" let insurance of insurances"[value]="insurance.id">{{insurance.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && i.insuranceId.errors">
            <span *ngIf="i.insuranceId.errors.required">Please select a insurance.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="plan" class="form-label">Plan<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layout'></i></span>
          <ng-select class="form-control rcx-ng-select" placeholder="Select insurance plan" formControlName="planId"
            [ngClass]="{'is-invalid': submitted && i.planId.errors}" [clearable]="false">
            <ng-option *ngFor=" let insurancePlan of empInsurancePlans"[value]="insurancePlan.id">{{insurancePlan.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && i.planId.errors">
            <span *ngIf="i.planId.errors.required">Please select a plan.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="message" class="form-label">Message <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-message-dots' ></i></span>
          <input type="text" class="form-control ps-1" id="message" placeholder="Enter the message"
            [ngClass]="{'is-invalid': submitted && i.message.errors}" formControlName="message" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && i.message.errors">
            <span *ngIf="i.message.errors.required">Please provide a valid message.</span>
            <span *ngIf="i.message.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="active" formControlName="active">
          <label class="form-check-label" for="active">Active</label>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
          <label class="form-check-label" for="disabled">Disabled</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{empInsuranceForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{empInsuranceForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>

<form [formGroup]="nomineeForm" (ngSubmit)="saveNominee(inProgress)" *ngIf="empInsuranceForm?.value?.id">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-user me-1 font-20 text-primary"></i>{{nomineeForm?.value.id?'Update':'Add'}} Nominee
    </h5>
  </div>
  <div class="modal-body" formArrayName="nominees">
    <div class="row g-3 insurance-plan-row" *ngFor="let nominee of nominees.controls; let i=index" [formGroupName]="i">
      <div class="col-md-3">
        <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="name" placeholder="Enter name"
            [ngClass]="{'is-invalid':nominee.get('name')?.touched && nominee.get('name')?.errors}"
            formControlName="name" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="nominee.get('name')?.touched  && nominee.get('name')?.errors">
            <span *ngIf="nominee.get('name')?.errors.required">Please provide a valid
              name.</span>
            <span *ngIf="nominee.get('name')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="percentage" class="form-label">Percentage <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"> %</span>
          <input type="text" class="form-control ps-1" id="percentage" placeholder="Enter percentage"
            [ngClass]="{'is-invalid':nominee.get('percentage')?.touched && nominee.get('percentage')?.errors}"
            formControlName="percentage" autocomplete="off" />
          <div class="invalid-feedback"
            *ngIf="nominee.get('percentage')?.touched  && nominee.get('percentage')?.errors">
            <span *ngIf="nominee.get('percentage')?.errors.required">Please provide a valid
              percentage.</span>
            <span *ngIf="nominee.get('percentage')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="address" class="form-label">Address <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="address" placeholder="Enter address"
            [ngClass]="{'is-invalid':nominee.get('address')?.touched && nominee.get('address')?.errors}"
            formControlName="address" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="nominee.get('address')?.touched  && nominee.get('address')?.errors">
            <span *ngIf="nominee.get('address')?.errors.required">Please provide a valid
              address.</span>
            <span *ngIf="nominee.get('address')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="pan" class="form-label">Pan <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-id-card'></i></span>
          <input type="text" class="form-control ps-1" id="pan" placeholder="Enter pan number"
            [ngClass]="{'is-invalid':nominee.get('pan')?.touched && nominee.get('pan')?.errors}" formControlName="pan"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="nominee.get('pan')?.touched  && nominee.get('pan')?.errors">
            <span *ngIf="nominee.get('pan')?.errors.required">Please provide a valid
              pan.</span>
            <span *ngIf="nominee.get('pan')?.errors.pattern">Please provide a valid
              pan.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="family" class="form-label">Family<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-book-content' ></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="familyId"
              placeholder="Select family" [ngClass]="{'is-invalid': nominee.get('familyId')?.touched && nominee.get('familyId')?.errors}"
              [clearable]="false">
            <ng-option *ngFor="let family of families" [value]="family.id">{{family.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="nominee.get('familyId')?.touched && nominee.get('familyId')?.errors">
            <span *ngIf="nominee.get('familyId')?.errors.required">Please select an family.</span>
            <span *ngIf="nominee.get('familyId')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>  
      <div class="col-md-3">
        <label for="relationshipProof" class="form-label">Relationship Proof</label>
        <div class="input-group">
          <input type="file" class="custom-file-input form-control" id="upload" (change)="getAndSetBase64($event)"
            accept=".jpg,.jpeg,.png" formControlName="relationshipProof">
        </div>
      </div> 
      <!-- <div class="col-md-3">
        <label for="relationshipProof" class="form-label">Relationship Proof <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-book-content' ></i></span>
          <input type="text" class="form-control ps-1" id="relationshipProof" placeholder="Enter relationship proof"
            [ngClass]="{'is-invalid':nominee.get('relationshipProof')?.touched && nominee.get('relationshipProof')?.errors}"
            formControlName="relationshipProof" autocomplete="off" />
          <div class="invalid-feedback"
            *ngIf="nominee.get('relationshipProof')?.touched  && nominee.get('relationshipProof')?.errors">
            <span *ngIf="nominee.get('relationshipProof')?.errors.required">Please provide a valid
              relationshipProof.</span>
            <span *ngIf="nominee.get('relationshipProof')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div> -->
      <div class="col-md-3">
        <label for="legalCompliance" class="form-label">Legal Compliance <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-book-content' ></i></span>
          <input type="text" class="form-control ps-1" id="legalCompliance" placeholder="Enter legal compliance"
            [ngClass]="{'is-invalid':nominee.get('legalCompliance')?.touched && nominee.get('legalCompliance')?.errors}"
            formControlName="legalCompliance" autocomplete="off" />
          <div class="invalid-feedback"
            *ngIf="nominee.get('legalCompliance')?.touched  && nominee.get('legalCompliance')?.errors">
            <span *ngIf="nominee.get('legalCompliance')?.errors.required">Please provide a valid
              legal compliance.</span>
            <span *ngIf="nominee.get('legalCompliance')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="notes" class="form-label">Notes <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-book-open' ></i></span>
          <input type="text" class="form-control ps-1" id="notes" placeholder="Enter notes"
            [ngClass]="{'is-invalid':nominee.get('notes')?.touched && nominee.get('notes')?.errors}"
            formControlName="notes" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="nominee.get('notes')?.touched  && nominee.get('notes')?.errors">
            <span *ngIf="nominee.get('notes')?.errors.required">Please provide a valid
              notes.</span>
            <span *ngIf="nominee.get('notes')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="prime" formControlName="prime">
          <label class="form-check-label" for="prime">Prime</label>
        </div>
      </div>
      <div class="col-md-auto mt-3 ms-auto me-0">
        <button type="submit" title="add insurance plan" *ngIf="i === nominees.length - 1"
          (click)="addNominee(nominee, i)" class="btn btn-secondary btn-sm me-2"> <i class='bx bx-plus' ></i> Add Nominee
        </button>
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteNominee(i, nominee)"> <i class='bx bx-trash'></i>Delete
        </button>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{nomineeForm?.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{nomineeForm?.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>
